import script from "./ModalConfirmarSenha.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalConfirmarSenha.vue?vue&type=script&setup=true&lang=js"

import "./ModalConfirmarSenha.vue?vue&type=style&index=0&id=55e8b6fd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-55e8b6fd"]])

export default __exports__